'use client';

import { jsx } from "react/jsx-runtime";
import { Text } from "../../Text/Text.js";
function renderPrefix({ icon: IconComponent, iconStyle, iconPosition, prefix }, disabled) {
  if (IconComponent && iconPosition === "lead") {
    return /* @__PURE__ */ jsx(
      IconComponent,
      {
        color: disabled ? "onLight.disabled.muted" : "onLight.icon.secondary",
        filled: iconStyle === "filled",
        size: "md"
      }
    );
  }
  if (prefix)
    return /* @__PURE__ */ jsx(
      Text,
      {
        "aria-hidden": "true",
        color: disabled ? "onLight.disabled.muted" : "onLight.text.tertiary",
        children: prefix
      }
    );
  return null;
}
export {
  renderPrefix
};
